

import Stepper from 'primevue/stepper';
import StepList from 'primevue/steplist';
import StepPanels from 'primevue/steppanels';
import StepItem from 'primevue/stepitem';
import Step from 'primevue/step';
import StepPanel from 'primevue/steppanel';

import IftaLabel from 'primevue/iftalabel';
import InputNumber from 'primevue/inputnumber';

import Card from 'primevue/card';
import Button from 'primevue/button';
import ProgressSpinner from 'primevue/progressspinner';

import { computed, defineComponent, onMounted, ref, watch } from 'vue';
import { useAuthStore } from '../../stores/auth';
import { storeToRefs } from 'pinia';
import { useWebStore } from '../../stores/web';
import { useToast } from 'primevue/usetoast';
import { showVuePopup } from '../../utils/showVuePopup';
import WalletUpdate from '../../popup/WalletUpdate.vue';
import { useSession } from '../../stores/session';
import { depositWithdraw } from '../../apis/deposit_withdraw';

export default defineComponent({
	name: 'DepositThPay',
	components: {
		Stepper,
		StepList,
		StepPanels,
		StepItem,
		Step,
		StepPanel,
		IftaLabel,
		InputNumber,
		Card,
		Button,
		ProgressSpinner,
	},
	setup() {
		const auth = useAuthStore();
		auth.hydrate();
		const {profile} = storeToRefs(auth);

		const web = useWebStore();
		web.hydrate();
		const { webPermission } = storeToRefs(web)

		const toast = useToast();

		const session = useSession();

		const stepper = ref<string>('1');
		watch(stepper, (stepper: string) => {
			console.log(stepper);
		})

		onMounted(() => {
			// handleGetAllService()
			handleGetMinMax()
		})

		const isActive = ref<boolean>(webPermission.value?.isDeposit.isAskmepay || false);

		const isBankUpdate = computed(() => !(!!profile.value?.customerBankAccount && !!profile.value?.customerBankName))

		const form = ref({
			amount: 0,
			btn: {
				disabled: false,
				loading: false,
			},
		});

		const amountLimit = ref({
			min: 0,
			max: 0,
		});

		const bankDeposit = ref({
			data: {

			},
			active: false,
			loading: false,
		});

		const handleSubmit = async () => {
			form.value.btn.loading = true;
			if (form.value.amount <= 0 || form.value.amount > amountLimit.value.max) {
				form.value.btn.loading = false;
				return
			}

			try {

				const payload = {
					amount: form.value.amount,
					serviceId: 100,
					redirectUrl: window.location.origin,
					bankName: 'SCB',
					type: 'BANK_TH',
					pin: '',
					serial: '',
					cardType: '',
				};

				const resp = await depositWithdraw.getQrcodeAskmepay(payload);

				if (resp.code !== '0') throw new Error(resp.message)

				console.log(resp);

				stepper.value = '2';
			} catch (error: any) {
				toast.add({ severity: 'error', summary: 'เกิดข้อผิดพลาดบางอย่าง', detail: error, life: 3000 });
			} finally {
				form.value.btn.loading = false;
			}
		};

		const handleGetAllService = async () => {
			try {
				const payload = {
					type: '',
				};

				const resp = await depositWithdraw.getAllServiceAskmepay(payload)

				if (resp.code !== '0') throw new Error(resp.message)

				console.log(resp);
			} catch (error: any) {
				toast.add({ severity: 'error', summary: 'เกิดข้อผิดพลาดบางอย่าง', detail: error?.message || String(error), life: 3000 });
			}
		}

		const handleGetMinMax = async () => {
			try {
				const payload = {
					serviceId: 100,
				};

				const resp = await depositWithdraw.getMinMaxAskmepay(payload)

				if (resp.code !== '0') throw new Error(resp.message)

				amountLimit.value.min = parseInt(resp.result.min)
				amountLimit.value.max = parseInt(resp.result.max)
			} catch (error: any) {
				toast.add({ severity: 'error', summary: 'เกิดข้อผิดพลาดบางอย่าง', detail: error?.message || String(error), life: 3000 });
			}
		}

		const btnClickUpdateBank = async () => {
			session.set('navbar_primary', 'wallet');
			session.set('navbar_sub', 'wallet:update');
			await showVuePopup(WalletUpdate, {tabs: 'bank'})
		}

		return {
			profile,
			stepper,
			form,
			amountLimit,
			handleSubmit,
			bankDeposit,
			isActive,
			isBankUpdate,
			btnClickUpdateBank,
		}
	},
})
